import React, { useEffect } from 'react';
import { Link } from "react-router-dom";
import './Category.css';

const Category = ({ categoryData }) => {
    useEffect(() => {
        if (categoryData.length && window.initCategory) {
            window.initCategory();
        }
    }, [categoryData]);

    return (
        <section className="flat-spacing-18">
            <div className="container">
                <div className="masonry-layout-v2">
                    {categoryData.map((category) => (
                    <div key={category.categoryId} className="collection-item-v5 hover-img wow fadeInUp" data-wow-delay="0s">
                        <div className="collection-inner">
                            <Link to={"/shop?categoryId=" + category.categoryId} className="collection-image img-style">
                                <img className="lazyload" data-src={category.imageSource} src={category.imageSource} alt={category.name}/>
                            </Link>
                            {/* <div className="collection-content">
                                <Link to={"/shop?categoryId=" + category.categoryId} className="collection-title"><span>{category.name}</span><i className="icon icon-arrow1-top-left"></i></Link>
                            </div> */}
                        </div>
                    </div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default Category